import { IconComponents } from "@suse-o11y/icons";
import React from "react";

import { BREADCRUMB_ICON_CLASS } from "../../../components/react/icon/Icon";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const ComponentsIndexBreadcrumb = () => (
	<BreadcrumbLayout
		icon={<IconComponents className={BREADCRUMB_ICON_CLASS} />}
		label={<div data-testid="components-breadcrumb">Components</div>}
	/>
);

ComponentsIndexBreadcrumb.PATH = "/components";
